import { render, staticRenderFns } from "./allProduct.vue?vue&type=template&id=3dee20b0&"
import script from "./allProduct.vue?vue&type=script&lang=js&"
export * from "./allProduct.vue?vue&type=script&lang=js&"
import style0 from "./allProduct.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "allProduct.vue"
export default component.exports